var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148597",
    "data-name": "Rectangle 148597",
    width: 24,
    height: 24,
    transform: "translate(295 628)",
    fill: "#ff411a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share",
    transform: "translate(-295 -628)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "next",
    transform: "translate(297.389 631.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_49",
    "data-name": "Union 49",
    d: "M9295.2,22065.18a.788.788,0,0,1-.582-.76v-.426c-.011-1.861-.027-4.674,1.273-7.088,1.49-2.752,4.314-4.242,8.4-4.447v-3.443a.784.784,0,0,1,.448-.709.842.842,0,0,1,.332-.072.781.781,0,0,1,.5.178l8.489,6.994a.8.8,0,0,1,.282.607.785.785,0,0,1-.282.6l-8.489,7.021a.8.8,0,0,1-.5.182.793.793,0,0,1-.786-.785v-3.422c-3.278.027-5.477.387-8.2,5.2a.78.78,0,0,1-.681.393A.8.8,0,0,1,9295.2,22065.18Zm10.648-11.961a.793.793,0,0,1-.775.785c-3.942.033-6.5,1.225-7.808,3.65a10.192,10.192,0,0,0-1.036,4.064,9.055,9.055,0,0,1,3.356-2.848,12.327,12.327,0,0,1,5.481-.824.812.812,0,0,1,.555.227.758.758,0,0,1,.232.555v2.541l6.468-5.355-6.474-5.344Z",
    transform: "translate(-9294.861 -22048.482)",
    fill: "#ff411a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.8291d764.svg";
export { ForwardRef as ReactComponent };